import React from 'react';
import { Container, Row } from 'react-bootstrap';

import { teamApi } from '../../api';
import { hasPermissions } from '../../utils';

import PageTitle from '../../components/common/PageTitle';
import EndUsersList from '../../components/common/endusers/EndUsersList';

function EndUsers({ t, user }) {
  return (
    <Container className="main-content-container settings-end-users p-3 p-md-5 d-flex flex-column flex-grow-1 d-flex flex-column flex-grow-1">
      <Row className="g-0 page-header mb-3 mb-md-5">
        <PageTitle title={t('admin.endUsers.title')} backBtn />
      </Row>

      <EndUsersList
        customer
        filterName={`team_${user.currentTeam.id}_end_users`}
        fetchData={teamApi.getEndUsers}
        fetchOptions={{ team: user.currentTeam.id }}
        generateRowUrl={(row) =>
          `/settings/end_user/${row.handle || row.original.user_handle}/profile`
        }
        // eslint-disable-next-line no-shadow
        hasPermissions={({ user }) => hasPermissions(user, 'transactions', 'Read')}
      />
    </Container>
  );
}

export default EndUsers;
